<template>
  <div class="team desktop-team">
    <div class="top">
      <div class="left">
        <div class="headline">Team</div>
        <table>
          <tr>
            <td>Michael</td>
            <td>Alexander Khuon</td>
          </tr>
          <tr>
            <td>Dina</td>
            <td>Anna Brüggemann</td>
          </tr>
          <tr>
            <td>Gertrud</td>
            <td>Isolde Barth</td>
          </tr>
          <tr>
            <td>Joachim</td>
            <td>Hanns Zischler</td>
          </tr>
          <tr>
            <td>Henriette</td>
            <td>Petra Schmidt-Schaller</td>
          </tr>
          <tr>
            <td>Hannah Garson</td>
            <td>Dulcie Smart</td>
          </tr>
          <tr>
            <td>Beata</td>
            <td>Nina Petri</td>
          </tr>
          <tr>
            <td>Matthias</td>
            <td>Andreas Döhler</td>
          </tr>
          <tr>
            <td>Patient im OP</td>
            <td>Rüdiger Vogler</td>
          </tr>
          <tr>
            <td>Arzt im Ultraschall</td>
            <td>Mark Waschke</td>
          </tr>
          <tr>
            <td>Zahnarzt</td>
            <td>Felix Goeser</td>
          </tr>
        </table>
      </div>
      <div class="right">
        <img src="@/assets/images/team/pic01.png" alt="" />
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <img src="@/assets/images/team/pic02.png" alt="" />
      </div>
      <div class="right">
        <table>
          <tr>
            <td>Regie</td>
            <td>Dietrich Brüggemann</td>
          </tr>
          <tr>
            <td>Buch</td>
            <td>Anna Brüggemann,</td>
          </tr>
          <tr>
            <td></td>
            <td>Dietrich Brüggemann</td>
          </tr>
          <tr>
            <td>Produzent*innen</td>
            <td>Martin Heisler,</td>
          </tr>
          <tr>
            <td></td>
            <td>Gabriele Simon</td>
          </tr>
          <tr>
            <td>Redaktion</td>
            <td>Cooky Ziesche (Rbb),</td>
          </tr>
          <tr>
            <td></td>
            <td>Barbara Häbe (Arte)</td>
          </tr>
          <tr>
            <td>Bildgestaltung</td>
            <td>Alexander Sass</td>
          </tr>
          <tr>
            <td>Schnitt</td>
            <td>Vincent Assmann</td>
          </tr>
          <tr>
            <td>Szenenbild</td>
            <td>Cosima Vellenzer</td>
          </tr>
          <tr>
            <td>Kostümbild</td>
            <td>Juliane Maier</td>
          </tr>
          <tr>
            <td>Maskenbild</td>
            <td>Annett Schulze</td>
          </tr>
          <tr>
            <td>Tonmeister</td>
            <td>Tobias Rüther</td>
          </tr>
          <tr>
            <td>Sound Supervisor</td>
            <td>Martin Frühmorgen</td>
          </tr>
          <tr>
            <td>Mischtonmeister</td>
            <td>Gregor Bonse</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.team {
  max-width: 2560px;
  margin-inline: auto;
  .top {
    height: 490px;
    background: transparent url('@/assets/images/inhalt/bg.jpg') top center
      no-repeat;
    background-size: cover;
    display: flex;
    .left,
    .right {
      width: 50%;
    }
    .left {
      color: white;
      font-size: 1.5rem;
      line-height: 1.8rem;
      padding-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .headline {
        width: 513px;
        font-family: 'Daft Brush';
        font-size: 4rem;
        line-height: 4.5rem;
        text-align: center;
      }
      table {
        width: 100%;
        max-width: 513px;
        tr {
          td:first-child {
            text-align: right;
            padding-right: 20px;
          }
          td:last-child {
            font-weight: 700;
          }
        }
      }
    }
    .right {
      display: flex;
      justify-content: flex-start;
      padding-left: 2em;
      align-items: center;
      @media (max-width: 1280px) {
        img {
          width: 90%;
        }
      }
    }
  }
  .bottom {
    height: 545px;
    display: flex;
    .left,
    .right {
      width: 50%;
    }
    .left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 2em;
      @media (max-width: 1280px) {
        img {
          width: 90%;
        }
      }
    }
    .right {
      font-size: 1.5rem;
      line-height: 1.8rem;
      padding-top: 20px;
      table {
        width: 100%;
        max-width: 513px;
        tr {
          td:first-child {
            text-align: right;
            padding-right: 20px;
          }
          td:last-child {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
